export class SeatingMapContext {

    public openClosePopup: boolean = false
    public seats!: Record<string, string>[]
    public bookingId: string = ""
    public coach: string = ""
    public layoutId: string =""
    
    public seatsData!: Record<string, string>
    public placeMapData!: any;
    public floorPlanIcon!: any;
    public coachLayoutData!: any;

    public preSelections!: Record<string, string>[];
    
    constructor() { }
}